import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { apiClient } from './api-client';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** UTC month-to-date; aligns with backend cost cache keys (scheduler + dashboard). */
export function getUtcMonthToDateRange(now: Date = new Date()): { start: Date; end: Date } {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const d = now.getUTCDate();
  return {
    start: new Date(Date.UTC(y, m, 1, 0, 0, 0, 0)),
    end: new Date(Date.UTC(y, m, d, 23, 59, 59, 999)),
  };
}

export function getUtcLastInstantOfCalendarMonth(now: Date = new Date()): Date {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  return new Date(Date.UTC(y, m + 1, 0, 23, 59, 59, 999));
}

function normalizeMasInstanceName(name: string): string {
  const n = String(name || '').trim();
  return n.toLowerCase().startsWith('ocp-') ? n.slice(4).toLowerCase() : n.toLowerCase();
}

export async function openMasLogin(params: {
  instanceName: string;
  clusterName: string;
  tenantCode: string;
  cloudProvider: string;
}): Promise<void> {
  try {
    const masInstanceName = normalizeMasInstanceName(params.instanceName);
    const coreNs = `mas-${masInstanceName}-core`;
    const routeName = `${masInstanceName}-auth-login`;
    const res = await apiClient.getOpenshiftRouteUrl(
      params.tenantCode,
      params.clusterName,
      params.cloudProvider,
      coreNs,
      routeName
    );
    if (res?.url) {
      const url = `${res.url}#/local`;
      window.open(url, '_blank');
    }
  } catch (e) {
    console.error('Failed to open Login:', e);
  }
}
